// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA_gC0hLMV_DKcGoNxE_aTBXYrAUOGe-Zc",
  authDomain: "tripp-c3a76.firebaseapp.com",
  databaseURL: "https://tripp-c3a76.firebaseio.com",
  projectId: "tripp-c3a76",
  storageBucket: "tripp-c3a76.appspot.com",
  messagingSenderId: "608927756317",
  appId: "1:608927756317:web:6aaaf61f049b74dadb56f4"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
